import { render } from "./ModalPaymentTransporter.vue?vue&type=template&id=4bbdc21e&scoped=true"
import script from "./ModalPaymentTransporter.vue?vue&type=script&lang=js"
export * from "./ModalPaymentTransporter.vue?vue&type=script&lang=js"

import "./ModalPaymentTransporter.vue?vue&type=style&index=0&id=4bbdc21e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbdc21e"]])

export default __exports__